import api from "./api";

export async function updateAccessToken(refresh_token) {
  return api.get("/refresh_token/");
}

export async function checkRegistrationCode (paylaod) {
  return api.post(`/user/check/code`, paylaod);
};
